import { useTheme } from "@emotion/react";
import React from "react";
import ReactSelect, {
  mergeStyles,
  Props as ReactSelectProps
} from "react-select";
import FluentReactSelectProps from "./props";

type Props = ReactSelectProps<any> & {
  selectRef?: any;
};

export const Select = (props: Props) => {
  const myTheme = useTheme();
  let mergedStyles = FluentReactSelectProps.styles(myTheme);

  if (props.styles) {
    mergedStyles = mergeStyles(
      FluentReactSelectProps.styles(myTheme)!,
      props.styles
    );
  }

  let mergedComponents = FluentReactSelectProps.components;

  if (props.components) {
    mergedComponents = {
      ...mergedComponents,
      ...props.components
    };
  }

  return (
    <ReactSelect
      {...props}
      styles={mergedStyles}
      theme={theme => {
        let mergedTheme = FluentReactSelectProps.theme(theme, myTheme);
        if (props.theme) {
          if (typeof props.theme === "function") {
            mergedTheme = {
              ...mergedTheme,
              ...props.theme(theme)
            };
          }
          //
          else {
            mergedTheme = {
              ...mergedTheme,
              ...props.theme
            };
          }
        }
        return mergedTheme;
      }}
      components={mergedComponents}
      ref={props.selectRef}
    />
  );
};
